/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Meta_TitleInputs */

const en_pc_tut_meta_title = /** @type {(inputs: Pc_Tut_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Tutorial: How to Use PdfCraft, Step by Step`)
};

const zh_pc_tut_meta_title = /** @type {(inputs: Pc_Tut_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 教程：一步步学会使用 PdfCraft`)
};

/**
* | output |
* | --- |
* | "PdfCraft Tutorial: How to Use PdfCraft, Step by Step" |
*
* @param {Pc_Tut_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_meta_title = /** @type {((inputs?: Pc_Tut_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_meta_title(inputs)
	return zh_pc_tut_meta_title(inputs)
});
export { pc_tut_meta_title as "pc.tut.meta_title" }